export const vatCodes = [
  {
    value: "AE",
    title: "Vat Reverse Charge",
    secondary: "Code specifying that the standard VAT rate is levied from the invoicee.",
  },
  {
    value: "E",
    title: "Exempt from Tax",
    secondary: "Code specifying that taxes are not applicable.",
  },
  {
    value: "S",
    title: "Standard rate",
    secondary: "Code specifying the standard rate.",
  },
  {
    value: "Z",
    title: "Zero rated goods",
    secondary: "Code specifying that the goods are at a zero rate.",
  },
  {
    value: "G",
    title: "Free export item, VAT not charged",
    secondary: "Code specifying that the item is free export and taxes are not charged.",
  },
  {
    value: "O",
    title: "Services outside scope of tax",
    secondary: "Code specifying that taxes are not applicable to the services.",
  },
  {
    value: "K",
    title: "VAT exempt for EEA intra-community supply of goods and services",
    secondary:
      "A tax category code indicating the item is VAT exempt due to an intra-community supply in the European Economic Area.",
  },
  {
    value: "L",
    title: "Canary Islands general indirect tax",
    secondary:
      "Impuesto General Indirecto Canario (IGIC) is an indirect tax levied on goods and services supplied in the Canary Islands (Spain) by traders and professionals, as well as on import of goods.",
  },
  {
    value: "M",
    title: "Tax for production, services and importation in Ceuta and Melilla",
    secondary:
      "Impuesto sobre la Producción, los Servicios y la Importación (IPSI) is an indirect municipal tax, levied on the production, processing and import of all kinds of movable tangible property, the supply of services and the transfer of immovable property located in the cities of Ceuta and Melilla.",
  },
  {
    value: "B",
    title: "Transferred (VAT), In Italy",
    secondary:
      "VAT not to be paid to the issuer of the invoice but directly to relevant tax authority. This code is allowed in the EN 16931 for Italy only based on the Italian A-deviation.",
  },
]
